<template>
  <div class="buy-course">
    <div class="buy-course_content">
      <transition name="fade">
        <ModalDiscount
          v-if="showModalDiscount"
          @closeModal="closeModalDiscount()"
        ></ModalDiscount>
      </transition>

      <transition name="fadeFast" mode="out-in">
        <router-view class="main_content"
                     v-if="showContent"
        ></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
  import ModalDiscount from "@/components/BuyCourse/PlatformBuyComponents/ModalWindows/ModalDiscount";
  import {emitter} from "../../databus";
  import {send} from "../../fetchData";

  export default {
    name: 'BuyCourseComponent',
    data(){
      return {
        showContent: false, // показать контент?
        showModalDiscount: false, // отобразить окно со скидкой
        urlPage: '',
        prevRoute: null,
        typeHeaderPoint: undefined, // тип хлебных крошек / full - полный / sliced - обрезанный (без выбора тарифа и выбора репетитора)
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },

    created() {
      if (Object.keys(this.$store.state.allCourses).length > 0) {
        this.showContent = true;
      }

      emitter.on('setAllCourses', () => {
        this.$nextTick(() => {
          this.showContent = true;
        })
      });

      emitter.on('openDiscountModal', () => {
        this.showModalDiscount = true;
      });

      this.getDiscountData();
    },

    mounted() {
      this.setTypeRouterBack();
    },

    watch:{
      '$route'(after, before) {
        if (after.name !== before.name) this.setTypeRouterBack();
      }
    },

    methods: {
      // устанавливает тип возврата для ПГК
      setTypeRouterBack() {
        const listRoutersSelectTariff = ['buySelectTariff', 'pgkBuySelectTariff']; // массив страниц выбора тарифа
        const typePage = this.$route.params.typePlatform;

        if (
          !listRoutersSelectTariff.includes(this.$route.name) &&
          (typePage === 'pgk') &&
          (this.typeHeaderPoint === undefined)
        ) {
          let data = {
            module: 'get_profile_info',
            course_id: this.$route.params.idCourse
          }

          send
            .post("user.php", data)
            .then((response) => {
              console.log(response);
              this.typeHeaderPoint = (response.get_teachers_groups)?('full'):('sliced');
            })
            .catch((error) => {
              console.log(error)
            })
        }
      },

      // получить данные о скидке
      getDiscountData() {
        let data = {
          module: 'check_bonus_timer',
        };

        send
          .post('course.php', data)
          .then((response) => {
            console.log('check_bonus_timer');
            console.log(response);

            let storeData = {
              dataReceived: true,
              bonus_timer: response.bonus_timer,
            }

            this.$store.commit('setDataDiscountModal', storeData);
          })
          .catch((error) => {
            console.log('Error check_bonus_timer');
            console.log(error.response);
          })
      },

      // закрыть модальное окно со скидкой
      closeModalDiscount() {
        this.showModalDiscount = false
      },

      /** Возвращает тип продукта по id
       * @returns {String} тип продукта
       * */
      getTypeProduct() {
        const course = this.$store.state.allCourses[this.$route.params.idCourse];
        if (course && course.type) return course.type
        return undefined
      },

      // перейти на стартовую страницу
      goToStartPage() {
        this.$router.push({name: 'start_page', params:{} });
      }
    },
    components:{
      ModalDiscount,
    }

  }
</script>

<style lang="scss" scoped>
  @import "../../../style/styles_fonts";

  $font_Geometria: Geometria, 'Geometria';

  $color_background: #F6F6FB;
  $color_Gray_1: #C5C5C9;
  $color_Gray_2: #ABABB2;
  $color_Gray_3: #EBEBEB;
  $color_Gray_4:  #F9F9F9;
  $color_Gray_5: #8D909F;
  $color_black: #333333;
  $color_purple: #8C71FE;
  $color_purple2: #F2F1FF;
  $color_purple3: #E2E2F6;
  $color_purple_4: #7B61EB;
  $color_purple_5:#6F57D6;
  $color_purple6: #B1A1F2;
  $color_red: #FF6597;
  $color_white: #FFFFFF;
  $color_cyan: #C0CADC;
  $color_cyan2: #AEBCD6;
  $color_green: #89CE54;

  .fade-enter-active, .fade-leave-active {
    transition: opacity ease .5s;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }

  .buy-course{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 72px 0 120px 0;
    background-color: #F6F6FB;
    font-family: $font_Geometria;
   // min-height: 100vh;
    color: $color_black;
  }

  .buy-course_content {
    display: flex;
    flex-direction: column;
    max-width: 1242px;
    width: 100%;
  }

  .logo {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    svg {
      cursor: pointer;
    }

    .go_back {
      cursor: pointer;
      display: flex;
      align-items: center;
      .svg {
        margin-right: 6px;
        display: flex;
        align-items: flex-end;
      }

      .text {
        font-family: $font_Geometria;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 23px;
        display: flex;
        align-items: flex-start;
        color: $color_purple;
      }
    }
  }
  .main_content{
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 28px;
  }

  @media all and (max-width: 1600px) {
    .buy-course{
      padding: 57px 0 120px 0;
    }

    .buy-course_content {
      max-width: 1172px;
    }

    .header{

      .go_back {

        .svg {
          margin-right: 6px;
        }

        .text {
          font-size: 18px;
          line-height: 23px;
        }
      }
    }

    .main_content{
      grid-gap: 28px;
    }
  }

  @media all and (max-width: 1440px) {
    .buy-course{
      padding: 42px 0 120px 0;
    }

    .buy-course_content {
      max-width: 1102px;
    }

    .header{

      .go_back {

        .svg {
          margin-right: 6px;
        }

        .text {
          font-size: 18px;
          line-height: 23px;
        }
      }
    }

    .main_content{
      grid-gap: 28px;
    }
  }

  @media all and (max-width: 1280px) {
    .buy-course{
      padding: 26px 0 120px 0;
    }

    .buy-course_content {
      max-width: 1032px;
    }

    .header{

      .go_back {

        .svg {
          margin-right: 6px;
        }

        .text {
          font-size: 18px;
          line-height: 23px;
        }
      }
    }

    .main_content{
      grid-gap: 28px;
    }
  }


  @media all and (max-width: 1160px) {
    .buy-course{
      padding: 30px 30px 120px 30px;
    }

    .header{

      .go_back {

        .svg {
          margin-right: 6px;
        }

        .text {
          font-size: 18px;
          line-height: 23px;
        }
      }
    }

    .main_content{
      grid-gap: 28px;
    }
  }

  @media all and (max-width: 960px) {

  }

  @media all and (max-width: 600px) {
    .buy-course{
      padding: 15px 15px 150px 15px;
    }

  }
</style>